exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".input-group-text.clear[data-v-cef371ee] {\n  cursor: pointer;\n}\n.input-group-text.clear[data-v-cef371ee]:hover {\n    color: white !important;\n    background-color: crimson;\n    border-color: black;\n    border-left: 2px solid black;\n}\n", ""]);

